import { request, download } from '@/utils/request'

const base = "/scrm";
export function upload (data) {
  return request({
    url: `${base}/file/upload`,
    //url: '/upload.json',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000,
    data: data
  })
}

// 文件列表 上传
export function getFileList(data) {
  return request({
    url: `/sys-file-ref/file-upload-list`,
    method: 'get',
    params: data
  })
}

// 文件列表 下载
export function getFileDownloadList(data) {
  return request({
    url: `/sys-file-ref/file-list`,
    method: 'get',
    params: data
  })
}

// 上传
export function uploadOne(data) {
  return request({
    url: `/sys-file-ref/file-upload`,
    method: 'post',
    data: data
  })
}

// 批量上传
export function batchUpload(data) {
  return request({
    url: `/sys-file-ref/full-file-upload`,
    method: 'post',
    data: data
  })
}

// 删除文件
export function fileDelete(data) {
  return request({
    url: `/sys-file-ref/file-batch-delete`,
    method: 'post',
    data: data
  })
}

// 锁定文件
export function fileLocked(data) {
  return request({
    url: `/sys-file-ref/file-locked`,
    method: 'post',
    data: data
  })
}

// 下载文件
export function attachmentDownload(data) {
  return download({
    url: `/sys-file-ref/file-download`,
    method: 'post',
    data: data
  })
}

//查询产品研发部下所有用户信息
export function queryProductDeptUser(data) {
  return request({
    url:`${base}/dingUser/query-product-dept-user`,
    method: 'post',
    data: data
  })
}

//查询用户列表
export function getDingUserList(data) {
  return request({
    url:`${base}/dingUser/get-list`,
    method: 'post',
    data: data
  })
}

/**
 * 通话记录详情
 * @param { string }  leadCallId 	通话id
 */
export function getCallDetail(data) {
  return request({
    url:`${base}/lead/callDetail`,
    method: 'post',
    data: data
  })
}

/**
 * ai意向标签下拉
 */
export function getAiIntentionTag(data) {
  return request({
    url:`${base}/lead/aiIntentionTagSelectList`,
    method: 'post',
    data: data
  })
}

/**
 * oss上传策略 - web直传
 */
export function ossPolicy (data) {
  return request({
    url: `${base}/aliyun/ossPolicy`,
    method: 'post',
    data: data
  })
}

/**
 * oss - 获取预览地址
 *
 * @param data {{imgUrl}} 文件名
 */
export function getUrlPreview (data) {
  return request({
    url: `${base}/aliyun/urlPreview`,
    method: 'post',
    data: data
  })
}

/**
 * oss - ocr 识别
 * @param data {{imgUrl}} 文件名
 */
export function getOcrInfo (data) {
  return request({
    url: `${base}/aliyun/ocr`,
    method: 'post',
    data: data
  })
}

/**
 * ai最后外呼状态-全量-无效线索
 */
export function getReplyStatusList(data) {
  return request({
    url:`${base}/lead/replyStatusList`,
    method: 'post',
    data: data
  })
}

/**
 * 车辆类型-二级分类
 */
export function getCarTypeList(data) {
  return request({
    url:`${base}/lead/carTypeSelectList`,
    method: 'post',
    data: data
  })
}

/**
 * 意向品牌-二级分类
 */
export function getBrandList(data) {
  return request({
    url:`${base}/lead/brandSelectList`,
    method: 'post',
    data: data
  })
}

/**
 * 人工意向标签下拉
 */
export function getUserIntention(data) {
  return request({
    url:`${base}/lead/userIntentionSelectList`,
    method: 'post',
    data: data
  })
}

/**
 * crm业务类型-下拉
 */
export function getBizTypeList(data) {
  return request({
    url:`${base}/lead/crm/bizTypeList`,
    method: 'post',
    data: data
  })
}

/**
 * 呼入状态列表-下拉
 */
export function callInStatus(data) {
  return request({
    url:`${base}/callIn/callInStatus`,
    method: 'post',
    data: data
  })
}

/**
 * 客服人员下拉-包含离职的停用的
 */
export function userAllList(data) {
  return request({
    url:`${base}/lead/userSelectList`,
    method: 'post',
    data: data
  })
}

/**
 * 客服人员下拉-当前客服 且状态正常的
 * 获取分配的客服下拉列表
 */
export function userNormalList(data) {
  return request({
    url:`${base}/user/selectList`,
    method: 'post',
    data: data
  })
}

/**
 * 客服人员下拉-剔除选择被继承的用户 
 * 继承账号列表
 */
export function userextendsList(data) {
  return request({
    url:`${base}/user/extendsUserList`,
    method: 'post',
    data: data
  })
}

/**
 * 客服人员下拉-核销人员下拉
 * 已成交下拉
 */
export function userFollowSelect(data) {
  return request({
    url:`${base}/lead/followUserSelectList`,
    method: 'post',
    data: data
  })
}

/**
 * 根据手机号获取通话记录
 */
export function callRecordByPhone(data) {
  return request({
    url:`${base}/call/callRecordListByPhone`,
    method: 'post',
    data: data
  })
}